// extracted by mini-css-extract-plugin
export default {"checkbox":"BriefcaseCheckbox_checkbox__AzUKC","checked":"BriefcaseCheckbox_checked__NYlmz","disabled":"BriefcaseCheckbox_disabled__wME7t"};